import Typesense from 'typesense';

// Este cliente se configurará una vez y se importará donde lo necesites.
export const typesenseClient = new Typesense.Client({
  nodes: [
    {
      host: process.env.REACT_APP_TYPESENSE_HOST, // Lo leeremos de un archivo .env
      port: '443',
      protocol: 'https',
    },
  ],
  // ¡MUY IMPORTANTE! Usa la llave de SÓLO BÚSQUEDA aquí.
  // Nunca expongas tu llave de Administrador en el código del frontend.
  apiKey: process.env.REACT_APP_TYPESENSE_SEARCH_ONLY_KEY,
  connectionTimeoutSeconds: 5,
});